import { render, staticRenderFns } from "./MtsTebligatGonderIslemDetayView.vue?vue&type=template&id=1a74fa54&scoped=true"
import script from "./MtsTebligatGonderIslemDetayView.vue?vue&type=script&lang=ts"
export * from "./MtsTebligatGonderIslemDetayView.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a74fa54",
  null
  
)

export default component.exports